var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SaveModal',_vm._b({attrs:{"color":"yellow","icon":"mdi-content-duplicate","maxWidth":_vm.maxWidth,"button":"Duplikovať","itemKey":_vm.itemKey,"fetchData":_vm.fetchData,"setTitle":_vm.setTitle,"setItemForm":_vm.setItemForm,"saveData":_vm.duplicateData},on:{"onSave":(response) => _vm.$emit('onDuplicate', response)},scopedSlots:_vm._u([{key:"default",fn:function({
        Item,
        errors,
        ItemForm
      }){return [_vm._t("default",null,{"Item":Item,"errors":errors,"ItemForm":ItemForm})]}}],null,true)},'SaveModal',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }